import {
  BURN_CHART_BAR_COLOR,
  BURN_CHART_IDEAL_COLOR,
  BURN_CHART_REAL_COLOR
} from './BurnChart.constants'
import {
  BurnChartData,
  BurnChartDirection,
  BurnChartProps,
  ComboChartData
} from './BurnChart.types'

export const getChartLimits = (data: BurnChartData) => ({
  maxValue: data[0],
  minValue: data[data.length - 1]
})

export const generateComboChartData = (
  data: BurnChartData,
  direction: BurnChartDirection
): ComboChartData => {
  const { maxValue } = getChartLimits(data)

  const idealStep = maxValue / (data.length - 1)

  const emptyHeader = ['', '', '', '']
  return [
    emptyHeader,
    ...data.map((row, index) => {
      const remainingEffort = row

      const idealLine =
        idealStep * (direction === 'down' ? data.length - 1 - index : index)

      const realLine =
        direction === 'down'
          ? maxValue - (maxValue - remainingEffort)
          : maxValue - remainingEffort

      return [index, remainingEffort, idealLine, realLine]
    })
  ] as ComboChartData
}

export const getDefaultOptions = (
  data: BurnChartData
): BurnChartProps['options'] => ({
  enableInteractivity: false,
  vAxis: {
    textStyle: {
      fontName: 'Barlow',
      fontSize: 12,
      color: '#303032',
      bold: true
    },
    gridlines: {
      color: '#e0e0e0'
    },
    ...getChartLimits(data)
  },
  hAxis: {
    gridlines: {
      color: '#e0e0e0'
    },
    textPosition: 'none'
  },
  seriesType: 'bars',
  series: {
    0: {
      // bars
      type: 'bars',
      color: BURN_CHART_BAR_COLOR,
      visibleInLegend: false
    },
    1: {
      // ideal line
      type: 'line',
      color: BURN_CHART_IDEAL_COLOR,
      lineWidth: 2,
      pointSize: 0
    },
    2: {
      // real line
      type: 'line',
      color: BURN_CHART_REAL_COLOR,
      lineWidth: 2,
      pointSize: 0
    }
  },
  legend: {
    position: 'none'
  },
  chartArea: {
    left: 50,
    right: 50,
    top: 20,
    bottom: 20
  },
  backgroundColor: '#ffffff',
  bar: {
    groupWidth: '60%'
  }
})
